const { gql } = require('@apollo/client');

export const SEGMENT_TREE = gql`
  mutation ($tileImage: Upload!, $zoom: Int!, $x: Int!, $y: Int!) {
    segmentTree(tileImage: $tileImage, zoom: $zoom, x: $x, y: $y) {
      id
    }
  }
`;
